import { AppRouter } from './routes';
import 'react-day-picker/style.css';
import { useFreshchat } from './features/support';
import { useCampaignTracking } from './features/campaign';
import { useTracking } from './lib/tracking';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  useFreshchat({ autostart: true });
  useTracking();
  useCampaignTracking();

  return (
    <BrowserRouter>
      {/* Inside the router: the error page renders the app layout, which
          navigates. The boundary in main.tsx only catches App's own hooks. */}
      <ErrorBoundary>
        <AppRouter />
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
